import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClientePacoteListarRoutingModule } from './central-cliente-pacote-listar-routing.module';
import { CentralClientePacoteListarComponent } from './central-cliente-pacote-listar.component';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';


@NgModule({
  declarations: [
    CentralClientePacoteListarComponent
  ],
  imports: [
    CommonModule,
    CentralClientePacoteListarRoutingModule,
    FormsModule,
    TableModule,
    DividerModule,
    ButtonModule,
    MessagesModule,
    InputTextModule,
    DropdownModule,
    TooltipModule,
    ProgressSpinnerModule,
    DialogModule
  ]
})
export class CentralClientePacoteListarModule { }
